export type KVPlaneIntersectionJSON = {
  planeIntersectionId: string
  planeIntersectionPoints: {
    x: number
    y: number
    z: number
  }[]
  planeIntersectionLabel: string
  planeIntersectionVisible: boolean
}

export class KVPlaneIntersection {
  id: string
  planeIntersectionPoints: {
    x: number
    y: number
    z: number
  }[]
  planeIntersectionLabel: string
  planeIntersectionVisible: boolean

  constructor(id: string) {
    this.id = id
    this.planeIntersectionPoints = []
    this.planeIntersectionLabel = 'Plane Intersection'
    this.planeIntersectionVisible = true
  }

  static fromJSON(json: KVPlaneIntersectionJSON): KVPlaneIntersection {
    const planeIntersection = new KVPlaneIntersection(json.planeIntersectionId)
    if (json.planeIntersectionPoints) {
      planeIntersection.planeIntersectionPoints = json.planeIntersectionPoints
    }
    planeIntersection.planeIntersectionLabel =
      json.planeIntersectionLabel || 'Plane Intersection'
    planeIntersection.planeIntersectionVisible =
      json.planeIntersectionVisible ?? true
    return planeIntersection
  }

  static toJSON(
    planeIntersection: KVPlaneIntersection
  ): KVPlaneIntersectionJSON {
    return {
      planeIntersectionId: planeIntersection.id,
      planeIntersectionPoints: planeIntersection.planeIntersectionPoints,
      planeIntersectionLabel: planeIntersection.planeIntersectionLabel,
      planeIntersectionVisible: planeIntersection.planeIntersectionVisible,
    }
  }
}
